export function ruleNotEmptyString(text: string) {
    return !!text || 'To pole jest wymagane'
}
